@if (progressBar()) {
  <aw-ticket-configuration-progress-tracker
    [backLink]="ERoute.directTickets"
    [progressBarContent]="
      progressBar()
    "></aw-ticket-configuration-progress-tracker>

  <div class="container mx-auto overflow-visible pb-12">
    <router-outlet></router-outlet>
  </div>
}
